import './JewelleryDetailModal.svelte.css';
/* src/components/JewelleryDetail/JewelleryDetailModal.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	component_subscribe,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal,
	set_store_value,
	src_url_equal
} from "../../../_snowpack/pkg/svelte/internal.js";

import { getContext } from '../../../_snowpack/pkg/svelte.js';
import JewelleryDetailModalContent from './JewelleryDetailModalContent.svelte.js';
import { jewelleryImagesCurrentIndex } from '../../stores/storeJewelleryDetail.js';

function create_fragment(ctx) {
	let button;
	let img;
	let img_src_value;
	let img_alt_value;
	let mounted;
	let dispose;

	return {
		c() {
			button = element("button");
			img = element("img");
			if (!src_url_equal(img.src, img_src_value = /*thumbSrc*/ ctx[0])) attr(img, "src", img_src_value);
			attr(img, "alt", img_alt_value = "" + (/*imgTypeText*/ ctx[1] + "画像詳細"));
			attr(img, "loading", "lazy");
			attr(img, "class", "svelte-16rdxfc");
			attr(button, "class", "jewellery-detail-popup svelte-16rdxfc");
		},
		m(target, anchor) {
			insert(target, button, anchor);
			append(button, img);

			if (!mounted) {
				dispose = [
					listen(button, "click", /*showDetail*/ ctx[2]),
					listen(button, "focus", /*setCurrentImgIndex*/ ctx[3]),
					listen(button, "mouseover", /*setCurrentImgIndex*/ ctx[3])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*thumbSrc*/ 1 && !src_url_equal(img.src, img_src_value = /*thumbSrc*/ ctx[0])) {
				attr(img, "src", img_src_value);
			}

			if (dirty & /*imgTypeText*/ 2 && img_alt_value !== (img_alt_value = "" + (/*imgTypeText*/ ctx[1] + "画像詳細"))) {
				attr(img, "alt", img_alt_value);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(button);
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $jewelleryImagesCurrentIndex;
	component_subscribe($$self, jewelleryImagesCurrentIndex, $$value => $$invalidate(6, $jewelleryImagesCurrentIndex = $$value));
	let { targetSrc } = $$props;
	let { thumbSrc } = $$props;
	let { imgTypeText } = $$props;
	let { imgIndex } = $$props;
	const { open } = getContext('simple-modal');

	const showDetail = () => {
		open(JewelleryDetailModalContent, { targetSrc });
	};

	const setCurrentImgIndex = () => {
		set_store_value(jewelleryImagesCurrentIndex, $jewelleryImagesCurrentIndex = imgIndex, $jewelleryImagesCurrentIndex);
	};

	$$self.$$set = $$props => {
		if ('targetSrc' in $$props) $$invalidate(4, targetSrc = $$props.targetSrc);
		if ('thumbSrc' in $$props) $$invalidate(0, thumbSrc = $$props.thumbSrc);
		if ('imgTypeText' in $$props) $$invalidate(1, imgTypeText = $$props.imgTypeText);
		if ('imgIndex' in $$props) $$invalidate(5, imgIndex = $$props.imgIndex);
	};

	return [thumbSrc, imgTypeText, showDetail, setCurrentImgIndex, targetSrc, imgIndex];
}

class JewelleryDetailModal extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			targetSrc: 4,
			thumbSrc: 0,
			imgTypeText: 1,
			imgIndex: 5
		});
	}
}

export default JewelleryDetailModal;